import Axios, { AxiosError } from 'axios'

// Axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost' : 'http://iot-api.jwelighting.com'
Axios.defaults.baseURL = '/api/'

Axios.interceptors.request.use(
    (config) => {
        console.log('Request', config)
        return config
    },
    (error) => {
        return Promise.resolve(error)
    }
)

const redirect = () => {
    localStorage.removeItem('auth')
    localStorage.removeItem('access_token')
    window.location.href = '/'
}

Axios.interceptors.response.use(
    (response) => {
        console.log('Response', response)
        return response
    },
    async (err: AxiosError) => {
        // console.log(err)
        if (err.response!.status === 401 || err.response!.status === 403) {
            redirect()
            return
        }
        return Promise.resolve(err)
    }
)

export default Axios
